import { List } from 'components';

const WorkExperienceDe: React.FC = () => {
  return (
    <>
      <List>
        <li>
          <strong>02/2018 - 02/2022 | Frontend-Entwickler</strong>
          <a href="https://brainst.pro/" target="_blank" rel="noreferrer">
            Brainst
          </a>
          &nbsp;(Projektbasiertem Einsatz)
        </li>

        <li>
          <strong>02/2019 - 02/2022 | Frontend-Entwickler</strong>
          <a href="https://beautyalliance-marketing.com/" target="_blank" rel="noreferrer">
            Beauty Alliance
          </a>
          &nbsp;(nebenbeschäftigung)
        </li>

        <li>
          <strong>02/2019 - 02/2022 | Frontend-Entwickler</strong>
          <a href="https://human-touch.ru/" target="_blank" rel="noreferrer">
            Human-Touch
          </a>
          &nbsp;(Projektbasiertem Einsatz)
        </li>

        <li>
          <strong>09/2015 - 01/2018 | Frontend-Entwickler</strong>
          <a href="https://mokselle.ru/" target="_blank" rel="noreferrer">
            Mokselle
          </a>
          &nbsp;(Remote)
        </li>
      </List>
    </>
  );
};

export default WorkExperienceDe;
